<template>
  <div>
    <div class="handle-line">
      <!-- <div>
        <span class="select-label">类型</span>
        <el-select
          class="ml10 my-select mr20"
          v-model="type"
          filterable
          placeholder="请选择类型"
          @change="getData"
        >
          <el-option
            v-for="(v, i) in typeOptions"
            :key="i"
            :label="v.label"
            :value="v.value"
          />
        </el-select>
      </div> -->
      <div class="time-box">
        <span class="select-label mr10">时间</span>
        <el-radio-group v-model="unitTrendAnalysisTimeType">
          <el-radio :label="1">日</el-radio>
          <el-radio :label="2">周</el-radio>
          <el-radio :label="3">月</el-radio>
          <el-radio :label="4">季</el-radio>
          <el-radio :label="5">年</el-radio>
        </el-radio-group>
        <!-- <div
          class="flex-box"
          v-if="radio == 4"
        >
          <el-date-picker
            class="date-picker ml10"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            v-model="dataRange"
            value-format="yyyy-MM-dd"
            clearable
            type="daterange"
          ></el-date-picker>
        </div> -->
      </div>
    </div>
    <div class="foot-btn">
      <el-button
        type="primary"
        @click="submit"
      >确 定</el-button>
    </div>
    <!-- <div class="content mt20">
      <div class="echart-box">
        <div class="chart_num">
          <span class="chart_name">1号机组</span>
        </div>
        <line-chart
          style="width: 88%"
          id="machine1"
          title=""
          ref="lineChart1"
        ></line-chart>
      </div>
      <div class="echart-box">
        <div class="chart_num">
          <span class="chart_name">2号机组</span>
        </div>
        <line-chart
          style="width: 88%"
          id="machine2"
          title=""
          ref="lineChart2"
        ></line-chart>
      </div>
      <div class="echart-box">
        <div class="chart_num">
          <span class="chart_name">3号机组</span>
        </div>
        <line-chart
          style="width: 88%"
          id="machine3"
          title=""
          ref="lineChart3"
        ></line-chart>
      </div>
    </div> -->
    <model-login-detail
      title="登录"
      width="25%"
      ref="modelLoginDetailRef"
    />

  </div>
</template>

<script>
import { api } from '@/api/api'
// import LineChart from '../echartComponents/LineChart.vue'
import ModelLoginDetail from './ModelLoginDetail.vue'
export default {
  components: { ModelLoginDetail },
  props: {
    modelType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      type: 1,
      unitTrendAnalysisTimeType: 1,
      dataRange: [],
      typeOptions: [{
        label: '效率',
        value: 1
      }, {
        label: '耗水率',
        value: 2
      }, {
        label: 'F值',
        value: 3
      }]
    }
  },
  methods: {
    submit() {
      let key = this.modelType == 'modelFour' ? 'unitHydraulicComparisonTimeType' : 'unitTrendAnalysisTimeType'
      let params = {
        url: api.updateSetting,
        data: {
          id: 1
        },
        token: localStorage.getItem('token')
      }
      params.data[key] = this.unitTrendAnalysisTimeType
      this.$http.put(params).then((res) => {
        if(res.data.code == 200) {
          this.$emit('getParams', { unitTrendAnalysisTimeType: this.unitTrendAnalysisTimeType })
        }else if(res.data.code == 500) {
          this.$message.error(res.data.msg)
        }else {
          this.$message.error('连接超时')
          this.$refs.modelLoginDetailRef.show()
        }
      })
    },
    getData() {
      this.$http.get({ url: api.getSetting }).then(res => {
        let key = this.modelType == 'modelFour' ? 'unitHydraulicComparisonTimeType' : 'unitTrendAnalysisTimeType'
        this.unitTrendAnalysisTimeType = res.data.data[key]
      })
    }
  }
}
</script>


<style scoped>
.handle-line /deep/ .el-radio__label {
  color: #fff !important;
}
.handle-line /deep/ .el-input--mini .el-input__inner {
  background: #0c2341 !important;
  border: 1px solid #1a4c89 !important;
  color: #fff !important;
}
.handle-line .data-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
.handle-line .my-select {
  width: 130px !important;
  background-color: #0c2342 !important;
}
.handle-line /deep/ .el-range-editor--mini .el-range-input {
  background: #0c2341 !important;
  color: #fff;
}
.handle-line .date-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
</style>

<style scoped lang="scss">
.handle-line {
  // display: flex;
  // align-items: center;
  .time-box {
    display: flex;
    align-items: center;
    margin: 10px 0 20px 0;
  }
  .select-label {
    color: #fff;
    font-size: 14px;
    margin-left: 20px;
    line-height: 28px;
  }
}
.content {
  .echart-box {
    display: flex;
    align-items: center;
    height: 150px;
    width: 100%;
    margin-top: 20px;
    .chart_num {
      color: #abd3ff;
      font-weight: bold;
      width: 10%;
      font-size: 12px;
      display: flex;
      justify-content: center;
      .chart_name {
        writing-mode: vertical-lr;
        text-orientation: upright;
        text-align: center;
        border: 1px solid #0a52a4;
        border-radius: 5px;
        padding: 18px 8px;
        background: #06112d;
        box-shadow: 0 -1px 3px 2px #073e7f;
        font-size: 18px;
      }
    }
  }
}
.foot-btn {
  text-align: end;
  margin-bottom: -30px;
}
</style>